export default class AudioAbstract {
    static getConfig() {
        return this._config;
    }
    static setConfig(value) {
        this._config = value;
    }
    constructor(config) {
        this.init(config);
    }
    init(config) {
        // this.audio = new Audio(config.src)
        console.log(config);
    }
    static getInstance() {
        if (!this.instance)
            this.instance = new this(this.getConfig());
        this.instance.audio = new Audio(this.getConfig().src);
        return this.instance;
    }
    ;
    play() {
        var _a;
        // try {
        (_a = this.audio) === null || _a === void 0 ? void 0 : _a.play().then(() => {
            delete this.audio;
        });
        console.log('audio');
        // } catch (e) {
        //     console.log('error')
        // }
    }
}
AudioAbstract._config = {
    src: ""
};
